// Exportação de dados da usuária (LGPD — ver Falha #4,
// docs/crochet/2026-07-15-RelatorioAceite.md). Mesmo padrão de chamada de
// deleteAccount em useAuth.ts: invoca a Edge Function (que já extrai o
// user_id do JWT da sessão atual — nada é passado no corpo) e devolve o
// JSON pronto para a UI compartilhar.
import { supabase } from '../../lib/supabase';

export async function exportUserData(): Promise<unknown> {
  const { data, error } = await supabase.functions.invoke('export-data');
  if (error) throw error;
  return data;
}
